import { createEditor as createSlateEditor } from 'slate';
import { withHistory } from 'slate-history';
import { withReact } from 'slate-react';

import { withMentions } from '../mentions/withMentions';

export const createEditor = () =>
  withMentions(withReact(withHistory(createSlateEditor())));
